import { render, staticRenderFns } from "./pregunta-nueva.vue?vue&type=template&id=a8fd34e2"
import script from "./pregunta-nueva.vue?vue&type=script&lang=js"
export * from "./pregunta-nueva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports